import { observable, computed, action } from "mobx";
import {Enc} from "../../tools/crypto";

export class Account {
	constructor(parent, name, abv) {
		this.parent = parent;
		this.name = name;
		this.abv = abv;
		this.lsEntry = "siu_account_" + name;

		const ls = JSON.parse(localStorage.getItem(this.lsEntry));
		if(ls) {
			this.localData = {
			 	id: ls.encrypted ? Enc.decrypt(ls.id) : (ls.id || this.localData.id),
			 	token: ls.encrypted 
					? (ls.token ? Enc.decrypt(ls.token) : 'abc')
					: (ls.token || this.localData.token),
			 	expiration: ls.expiration || this.localData.expiration
			}
		}
	}

	@observable profile = {
		displayName: "",
		avatar: "",
	};

	@observable localData = {
		id: "",
		token: "abc",
		expiration: 0,
	};

	@observable.deep serverData = {
		AnonymousUsername: "",
		UserId: ''
	};

	@computed get isConnected() {
		return this.localData && this.localData.id !== "";
	}

	applyToLocalStorage = () => {
		const {id, token} = this.localData;
		// encrypt
		const data = {...this.localData,
		 	id: (id !== '' && Enc.shouldCrypt) ? Enc.encrypt(id) : id,
			token: (token !== '' && Enc.shouldCrypt) ? Enc.encrypt(token) : token,
		 	encrypted: Enc.shouldCrypt
		}
		setPersistentStorage(this.lsEntry, JSON.stringify(data));
	};


	@action updateDataFromServer(data) {
		this.serverData = data;
		this.localData.id = this.serverData.AnonymousUsername;
		this.applyToLocalStorage();
		return this.serverData;
	}
}
